export enum OpsIntAction {
  CLEAR,
  RESEND_DEAL,
  RESEND_ORDER,
  MIGRATE,
  CANCEL,
  RESOLVE,
  MANUAL_DEAL_REF_REQUIRED,
}

export namespace OpsIntAction {
  let elements = [
    OpsIntAction.CLEAR,
    OpsIntAction.RESEND_DEAL,
    OpsIntAction.RESEND_ORDER,
    OpsIntAction.MIGRATE,
    OpsIntAction.CANCEL,
    OpsIntAction.RESOLVE,
    OpsIntAction.MANUAL_DEAL_REF_REQUIRED,
  ];
  let alias = "com.bcdfx.model.OpsIntAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
